import React from "react";
import { FaGooglePlay, FaApple } from "react-icons/fa";
import { CheckCircle2, QrCode, Smartphone } from "lucide-react";
import mob_img from "../../../assets/images/mob-banner.png";
import qr_img from "../../../assets/images/qr-code.png";
import "./PromoBanner.css";

const APP_FEATURES = [
  "Search & filter thousands of verified properties in real-time",
  "Save favorite listings & receive instant price drop alerts",
  "Schedule instant guided property visits with local experts",
  "Directly chat with verified property owners and partners",
];

const PromoBanner = () => (
  <section className="promo">
    <div className="promo__container">
      <div className="promo__grid">
        <div className="promo__content">
          <div className="promo__badge">
            <Smartphone size={13} />
            <span>Mobile App Experience</span>
          </div>

          <h2 className="promo__title">
            Find Your <em>Perfect Property</em> on the Go
          </h2>

          <p className="promo__text">
            Download the All Home Desire mobile app to explore verified homes, save favorite listings, and manage your property search anytime, anywhere.
          </p>

          <div className="promo__features">
            {APP_FEATURES.map((feat) => (
              <div key={feat} className="promo__feature-item">
                <CheckCircle2 size={16} className="promo__feature-icon" />
                <span>{feat}</span>
              </div>
            ))}
          </div>

          <div className="promo__actions">
            <div className="promo__store-links">
              <a
                href="https://play.google.com/store/apps/details?id=com.AllHomeDesire.AllHomeDesire"
                target="_blank"
                rel="noopener noreferrer"
                className="promo__store-btn"
              >
                <span className="promo__store-btn-icon">
                  <FaGooglePlay size={20} />
                </span>
                <span className="promo__store-btn-text">
                  <span className="promo__store-btn-sub">Get it on</span>
                  <span className="promo__store-btn-name">Google Play</span>
                </span>
              </a>

              <a
                href="https://apps.apple.com"
                target="_blank"
                rel="noopener noreferrer"
                className="promo__store-btn"
              >
                <span className="promo__store-btn-icon">
                  <FaApple size={22} />
                </span>
                <span className="promo__store-btn-text">
                  <span className="promo__store-btn-sub">Download on the</span>
                  <span className="promo__store-btn-name">App Store</span>
                </span>
              </a>
            </div>

            <div className="promo__qr-card">
              <img src={qr_img} alt="Scan QR code" className="promo__qr-img" />
              <div className="promo__qr-info">
                <QrCode size={14} />
                <span>Scan to Download</span>
              </div>
            </div>
          </div>
        </div>

        <div className="promo__visual">
          <div className="promo__phone-glow" />
          <img src={mob_img} alt="All Home Desire Mobile App" className="promo__phone-img" />
        </div>
      </div>
    </div>
  </section>
);

export default PromoBanner;